import { setUnchangedPositions, retainKeys } from '@moleculeone/draw';
import { M4, V4 } from '@moleculeone/utils';

import { MOL_MOUSE_EVENT, MOUSE_DOWN, MOUSE_MOVE, MOUSE_UP, ROTATE_MODE } from '../../../../etc/constants';
import { updateMols, updateState } from '../../../state';

export function effect(state, action) {
  if (action.type !== MOL_MOUSE_EVENT) {
    return {};
  }
  return baseEffect(state.mols, state.mode, state.selected, action.event, state.mouse.molIndex);
}

function baseEffect(mols, mode, selected, event, molIndex) {
  const data = mode.data;
  let newData = initial.data;
  let newMol = mols[molIndex];
  let selection = selected[molIndex];

  if (event.type === MOUSE_MOVE && data.start != null && data.dir == null && V4.dist(data.start, event.svgPos) > 25) {
    newData = { start: data.start, dir: event.svgPos };
  } else if (event.type === MOUSE_MOVE) {
    return {};
  }

  if (event.type === MOUSE_DOWN && data.start != null) {
    //
  } else if (event.type === MOUSE_UP && data.dir == null) {
    //
  } else if (event.type === MOUSE_DOWN && data.start == null) {
    if (event.atom) {
      newData = { start: mols[molIndex].positions[event.idx] };
    } else {
      newData = { start: event.svgPos };
    }
  } else if (event.type === MOUSE_UP && data.dir != null) {
    newMol = rotate(mols[molIndex], data.start, data.dir, event.svgPos, selection);
  }
  return {
    mols: updateMols(mols, newMol, molIndex),
    mode: updateState(mode, { data: newData }),
  };
}

export function rotate(mol, start, dir, now, selected) {
  const group = selected.length === 0 ? mol.positions : retainKeys(mol.positions, selected);
  const angle = V4.angleZ(V4.sub(now, start), V4.sub(dir, start));
  const mat = M4.mulM(M4.moveTo(start), M4.rotZ(angle), M4.moveFrom(start));
  const newPositions = selected.length === 0 ? M4.map(mat, group) : updateState(mol.positions, M4.map(mat, group));
  return setUnchangedPositions(mol, newPositions);
}

export function preview(state) {
  const data = state.mode.data;
  const { lastMove, molIndex } = state.mouse;
  if (data.dir != null && lastMove != null) {
    return rotate(state.mols[molIndex], data.start, data.dir, lastMove.svgPos, state.selected[molIndex]);
  }
  return null;
}

function cleanup(mode) {
  return mode;
}

const initial = {
  type: ROTATE_MODE,
  data: {},
};

export const trait = {
  type: ROTATE_MODE,
  initial,
  effect,
  preview,
  cleanup,
};
